import { httpsCallable } from "firebase/functions";
import { cloudFunctions } from "./getFunctions";
import {
  RegistrarEmpresa,
  CloudFunctionResponse,
  CallablesGeneral
} from "@fixeduy/restaurantestypes";

const registrarEmpresa = async (
  data: RegistrarEmpresa
): Promise<CloudFunctionResponse> => {
  const run = httpsCallable<CallablesGeneral, CloudFunctionResponse>(
    cloudFunctions,
    "callablesGenerales"
  );
  const result = await run({
    func: "registrarEmpresa",
    params: data
  });
  return result.data;
};

export { registrarEmpresa };
